import { EngagementFragment, EngagementType } from 'src/gql/graphql'

export const parseType = (type: EngagementType) => {
  switch (type) {
    case EngagementType.InAppMessaging:
      return 'In app messaging (unscheduled)'
    case EngagementType.InAppMessagingScheduled:
      return 'In app messaging (scheduled)'
    case EngagementType.InPerson:
      return 'In person'
    case EngagementType.PhoneCall:
      return 'Phone call'
    case EngagementType.TextMessaging:
      return 'Text messaging'
    case EngagementType.VideoCall:
      return 'Video call'
    case EngagementType.Other:
      return 'Other'
  }
}

export const formatStartedAt = ({ startedAt }: EngagementFragment) =>
  startedAt.toFormat("LLL dd, yyyy 'at' h:mm a ZZZZ")
